import React, { useState } from 'react';
import { useI18n } from '@whizz/react-i18n';
import type { ClassReportType } from '../../types';
import type { ManageMetricsType } from '../../../forms/types';
import type { DateRange } from '../../../util/types';
import { ReportTable } from '../sections';
import AssessmentInfo from '../modules/AssessmentInfo';
import LessonHistory from '../LessonHistory';

type Props = {
  classReport: ClassReportType;
  filterLabel: string | null;
  filteredIds: number[] | null;
  showOthersData: boolean;
  metricsSettings: ManageMetricsType;
  dateRange: DateRange;
  groupId: number;
};

const TablesView = ({ classReport, filteredIds, filterLabel, showOthersData, metricsSettings, dateRange, groupId }: Props): JSX.Element => {

  const { translate } = useI18n();

  const [ lessonHistoryId, setLessonHistoryId ] = useState<number | null>(null);

  const filteredStudentsUnderAssessment: number[] =
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    filteredIds!.filter((r) => classReport.students.unassessedOrReassessedStudents.map((student) => student.id).includes(r));

  const underAssessmentLabelValue = (): string => {
    if (filteredStudentsUnderAssessment.length > 1) {
      return `${(filteredStudentsUnderAssessment.length)} ${translate('global.STUDENT_plural')}`;
    } else {
      return classReport.students.unassessedOrReassessedStudents.filter((student) => student.id === filteredStudentsUnderAssessment[0])[0].fullName;
    }
  };

  const lessonHistoryStudent = lessonHistoryId ? classReport.students.all.find((student) => student.id === lessonHistoryId) : null;

  return (
    <div id={'table-container'}>
      {filteredStudentsUnderAssessment.length > 0 && (
        <AssessmentInfo
          title={translate('pages.REPORTS.TABLE_VIEW.under_assessment')}
          highlightCardLabel={underAssessmentLabelValue()}
        />
      )}
      { lessonHistoryStudent ? (
        <LessonHistory
          student={{ childId: lessonHistoryStudent.childId, fullName: lessonHistoryStudent.fullName }}
          groupId={groupId}
          dateRange={dateRange}
          onClose={() => setLessonHistoryId(null)}
          hideHeader
        />)
        : null }
      <ReportTable
        classReport={classReport}
        filterLabel={filterLabel}
        highlightedIds={filteredIds}
        showOthersData={showOthersData}
        metricsSettings={metricsSettings}
        onStudentClick={(id) => setLessonHistoryId(id)}
      />
    </div>
  );
};

TablesView.displayName = 'TablesView';

export default TablesView;
